import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be83c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepCarFTL" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_3 = { class: "StepCarFTL__title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-chevron-up"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-chevron-down"
}
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepCarFTL__title" }, "Дополнительные услуги", -1))
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = {
  key: 0,
  class: "fas fa-chevron-up"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-chevron-down"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_13 = { class: "StepCarFTL__grid" }
const _hoisted_14 = { class: "flex flex-col mt-2" }
const _hoisted_15 = { class: "StepCarFTL__holder" }
const _hoisted_16 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_19 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Авто", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Рохля", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Паллета", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Мягкая упаковка", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Обрешетка", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Манипулятор", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Грузчики", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Кран", -1))
const _hoisted_29 = { class: "flex items-center justify-end" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isCompleted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            (_ctx.stepNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.stepNumber) + ".", 1))
              : _createCommentVNode("", true),
            _createTextVNode(" Дополнительные услуги (не обязательно) ")
          ]),
          (_ctx.toggle)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small",
                disabled: _ctx.disabled,
                onClick: _ctx.toggleForm
              }, {
                default: _withCtx(() => [
                  (_ctx.state_toggle.is_open)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : (_openBlock(), _createElementBlock("i", _hoisted_6))
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_ctx.toggle)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "primary small mr-2",
                  disabled: _ctx.disabled,
                  onClick: _ctx.toggleForm
                }, {
                  default: _withCtx(() => [
                    (_ctx.state_toggle.is_open)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                      : (_openBlock(), _createElementBlock("i", _hoisted_11))
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.disabled,
              onClick: _ctx.resetForm
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.isCompleted)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "mt-3",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasCar,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.hasCar) = $event)),
                      label: "Авто"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasCrane,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.hasCrane) = $event)),
                      label: "Кран"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasGrid,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.hasGrid) = $event)),
                      label: "Обрешетка"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasHydraulicTrolley,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.hasHydraulicTrolley) = $event)),
                      label: "Рохля"
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_checkbox, {
                        value: _ctx.state.hasLoader,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.hasLoader) = $event)),
                        label: "Грузчики"
                      }, null, 8, ["value"]),
                      (_ctx.state.hasLoader)
                        ? (_openBlock(), _createBlock(_component_the_input, {
                            key: 0,
                            class: "ml-3",
                            placeholder: "Количество",
                            value: _ctx.additional_state.loader_value,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.additional_state.loader_value) = $event)),
                            "is-invalid": _ctx.state_form$.loader_value.$error,
                            "validation-errors": _ctx.state_form$.loader_value.$errors
                          }, null, 8, ["value", "is-invalid", "validation-errors"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasManipulator,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.hasManipulator) = $event)),
                      label: "Манипулятор"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasPallet,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.hasPallet) = $event)),
                      label: "Паллета"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.hasSoftPackage,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.hasSoftPackage) = $event)),
                      label: "Мягкая упаковка"
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_the_button, {
                    type: "submit",
                    class: "primary text small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  })
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _hoisted_20,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasCar ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasHydraulicTrolley
                                    ? 'Да'
                                    : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasPallet ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasSoftPackage ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_24,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasGrid ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_25,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasManipulator ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _createElementVNode("span", null, _toDisplayString(_ctx.completed_state.additional_service?.hasLoader ? 'Да ' : 'Нет'), 1),
                    (_ctx.completed_state.additional_service?.hasLoader)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, " (" + _toDisplayString(_ctx.getLoaderText) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_28,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.additional_service?.hasCrane ? 'Да' : 'Нет'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_the_button, {
                    class: "primary text small",
                    disabled: _ctx.disabled,
                    onClick: _ctx.updateAdditionalServices
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30,
                      _createTextVNode(" Редактировать ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}